import { Text } from '@bp-digital/component-typography'
import getBrandFromDomain from 'helpers/getBrandFromDomain'
import { BRAND_ARAL, BRAND_BP } from 'constants/brands'
import { Logo, LogoWrapper } from '../Authentication/LoginPage/LoginPage.styled'
import { Content } from '../MaintenancePage/MaintenancePage.styled'
import PublicLayout from 'components/layout/PublicLayout'
import getFallbackLanguage from 'helpers/getFallbackLanguage'
import bpLogo from 'assets/logos/bp-logo-colour.svg'
import aralLogo from 'assets/logos/aral-logo.svg'
import { LOCALE_DE } from 'src/constants/locales'

const MaintenancePage = () => {
  const brand = getBrandFromDomain()
  const language = getFallbackLanguage()

  let de_email
  if (brand === BRAND_BP && language === LOCALE_DE) {
    de_email = 'GATFVCBSCTeam@bp.com'
  } else {
    de_email = 'info@aralcard.de'
  }

  let message
  switch (language) {
    case 'en':
      message = (
        <Text>
          We want to let you know that our portal will be undergoing scheduled maintenance to enhance our
          services.During this period, the portal will be temporarily inaccessible.We apologize for any inconvenience
          this may cause and appreciate your understanding.Our team is working hard to get the portal back online as
          soon as possible.For more details, Please <a href={`mailto:bpcardsadmin@uk.bp.com`}>contact support.</a>
        </Text>
      )
      break
    case 'nl':
      message = (
        <Text>
          Wij willen u informeren dat ons portaal geplande onderhoudswerkzaamheden zal ondergaan om onze diensten te
          verbeteren. Gedurende deze tijd zal het portaal tijdelijk niet beschikbaar zijn. Wij verontschuldigen ons voor
          enig ongemak en waarderen uw begrip. Ons team werkt hard om het portaal zo snel mogelijk weer operationeel te
          krijgen.Neem voor meer informatie. <a href={`mailto:cardsupport@bp.com`}>contact op met de ondersteuning</a>
        </Text>
      )
      break
    case 'de':
      message = (
        <Text>
          Wir möchten Sie darüber informieren, dass unser Portal planmäßige Wartungsarbeiten durchführen wird, um unsere
          Dienstleistungen zu verbessern. Während dieser Zeit wird das Portal vorübergehend nicht verfügbar sein. Wir
          entschuldigen uns für etwaige Unannehmlichkeiten und danken Ihnen für Ihr Verständnis. Unser Team arbeitet
          intensiv daran, das Portal so schnell wie möglich wieder in Betrieb zu nehmen.Für weitere Details{' '}
          <a href={`mailto:${de_email}`}>kontaktieren Sie bitte den Support</a>
        </Text>
      )
      break
    case 'pl':
      message = (
        <Text>
          Chcielibyśmy poinformować, że nasze portal przejdzie zaplanowaną konserwację w celu poprawy naszych usług. W
          tym czasie portal będzie tymczasowo niedostępny. Przepraszamy za wszelkie niedogodności i dziękujemy za
          zrozumienie. Nasz zespół pracuje intensywnie, aby portal był jak najszybciej ponownie dostępny{' '}
          <a href={`mailto:gpolandfuelcards@bp.com`}> Prosimy o kontakt</a>
        </Text>
      )
      break
    case 'pt':
      message = (
        <Text>
          Gostaríamos de informar que nosso portal passará por uma manutenção programada para melhorar nossos serviços.
          Durante esse período, o portal ficará temporariamente indisponível. Pedimos desculpas por qualquer
          inconveniente e agradecemos sua compreensão. Nossa equipe está trabalhando diligentemente para garantir que o
          portal esteja de volta ao funcionamento o mais rápido possível{' '}
          <a href={`mailto:clientebpplus@bp.com`}>Por favor, entre em contato com</a>
        </Text>
      )
      break
    default:
      message = (
        <Text>
          We want to let you know that our portal will be undergoing scheduled maintenance to enhance our
          services.During this period, the portal will be temporarily inaccessible.We apologize for any inconvenience
          this may cause and appreciate your understanding.Our team is working hard to get the portal back online as
          soon as possible.For more details, Please <a href={`mailto:bpcardsadmin@uk.bp.com`}>contact support.</a>
        </Text>
      )
  }
  return (
    <PublicLayout justifyContent='center' boxMinWidth='500px'>
      <LogoWrapper>
        <Logo src={brand === BRAND_ARAL ? aralLogo : bpLogo} />
      </LogoWrapper>
      <Content>{message}</Content>
    </PublicLayout>
  )
}

export default MaintenancePage
